import React from 'react';
import { useNavigate } from 'react-router-dom';

const AutorizacionMiembros = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-gray-100">
            <div className="w-full max-w-2xl p-8 bg-white rounded-lg shadow-lg">

                <h2 className="text-xl font-bold mb-4 text-[#1f94c2ff] text-center">
                    Autorización para tratamiento de datos personales para afiliados
                </h2>
                
                <p className="mb-4 text-gray-700 leading-relaxed">
                    Yo, declaro que, actuando en nombre propio, de manera libre, previa, expresa, voluntaria e informada, autorizo de forma explícita a la <b className="font-semibold">RED COLOMBIANA DE PRESTACIÓN Y CUIDADOS EN SALUD S.A.S.</b>, de ahora en adelante REDPLIKA, identificada con el NIT 901.823.589-6, domiciliada en la Carrera 45 A # 95-37 Oficina 604, Bogotá D.C. (Cundinamarca), con dirección electrónica <a href="mailto:Info@redplika.co" className="text-[#1f94c2ff] hover:underline">Info@redplika.co</a> y número telefónico +57 322 9280050, para que recolecte, almacene, utilice, circule, actualice y suprima los datos personales que he suministrado en el marco de mi vinculación como miembro de su comunidad.
                </p>

                <p className="mb-4 text-gray-700 leading-relaxed">
                    Esta autorización comprende el tratamiento de mis datos personales de identificación, contacto, información académica, profesional, y cualquier otro dato que haya sido o sea proporcionado voluntariamente por mí durante mi participación en la red, con las siguientes finalidades:
                </p>

                <ul className="list-disc list-inside mb-4 ml-4 text-gray-700 space-y-2">
                    <li>Gestionar mi vinculación, permanencia y participación activa como miembro de la comunidad REDPLIKA.</li>
                    <li>Facilitar mi interacción con otros miembros, usuarios y aliados del ecosistema.</li>
                    <li>Enviarme información sobre eventos, convocatorias, actividades, boletines y comunicaciones relacionadas con las iniciativas de innovación, salud y bienestar promovidas por REDPLIKA.</li>
                    <li>Contactarme para participar en procesos de co-creación, formación, encuestas o estudios relacionados con el objeto de la organización.</li>
                    <li>Cumplir con las obligaciones legales, contractuales y estatutarias aplicables a REDPLIKA.</li>
                </ul>

                <p className="mb-4 text-gray-700 leading-relaxed">
                    Declaro haber sido informado(a) de que mis derechos como titular de los datos personales incluyen conocer, actualizar, rectificar y suprimir los datos suministrados, así como revocar esta autorización, mediante solicitud presentada a través del correo electrónico <a href="mailto:Info@redplika.co" className="text-[#1f94c2ff] hover:underline">Info@redplika.co</a> o en la dirección física antes indicada.
                </p>
                
                <p className="mb-4 text-gray-700 leading-relaxed">
                    He sido informado(a) de que mis datos serán tratados conforme a la Política de Tratamiento de Datos Personales de REDPLIKA, la cual se encuentra disponible en el sitio web <a href="https://www.redplika.co" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">www.redplika.co</a>, y que el tratamiento se realizará bajo estrictas medidas de seguridad, confidencialidad y conforme a la normatividad vigente en Colombia (Ley 1581 de 2012 y normas concordantes).
                </p>
            </div>
        </div>
    );
};

export default AutorizacionMiembros;
